import Footer from "../components/Footer/Footer";
import Authentication from "../components/SignInUp/Authentication";
// import Navbar from "../components/Navbar/Navbar"
import Navbarf from "../components/Navbar/Navbarf";

const About = () => {
    return (
        <>
        <Navbarf/>
            <Authentication />

            <Footer />
        </>
    )
}

export default About

